<template>
  <div>
    <h3 class="title is-3">Receiving</h3>
    <hr />
    <div class="level">
      <div class="level-left">
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination
      :tableData="purchaseOrders.data"
      :search="search"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :mobileCards="true"
      :loading="isLoadingTable"
      :page="page"
      :perPage="perPage"
      :totalData="purchaseOrders.totalData"
      :placeholder="'Search by Product, Supplier, Client P.O Number P.O Number & Client'"
      @onPageChanged="page = $event"
      @onSearchChanged="search = $event"
      @onPerPageChanged="perPage = $event"
    >
      <template slot="row-content" slot-scope="{ item }">
        <b-table-column class="table-column-content-is-small" label="P.O #">
          {{ item.row.poNum }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Supplier">
          {{ item.row.supplier }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="P.O date">
          {{ item.row.poDate }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Product">
          {{ item.row.productName }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Total QTY">
          {{ item.row.quantity }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="QTY Received"
        >
          {{ item.row.qtyReceived }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          style="text-align: right"
          label="Initial Cost"
        >
          {{ item.row.initialCost }}
        </b-table-column>
        <!-- <b-table-column
          class="table-column-content-is-small"
          style="text-align: right"
          label="Total Amount"
        >
          {{ item.row.totalAmount }}
        </b-table-column> -->
        <b-table-column
          class="table-column-content-is-small"
          style="text-align: right"
          label="Client"
        >
          {{ item.row.client }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          style="text-align: right"
          label="Client P.O #"
        >
          {{ item.row.clientPoNumber }}
        </b-table-column>
        <!-- <b-table-column
          class="table-column-content-is-small"
          label="Adaptive Sales"
        >
          <span v-if="item.row.isAdaptive">Yes</span>
          <span v-else>No</span>
        </b-table-column> -->
        <b-table-column class="table-column-content-is-small" label="Received?">
          <span v-if="item.row.isReceived === true">Yes</span>
          <span v-else>No</span>
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Receive By"
        >
          <span style="font-weight: bold">{{ item.row.receivedBy }}</span>
          <span v-if="item.row.receivedDate">
            - {{ item.row.receivedDate }}</span
          >
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button
            class="button is-small"
            @click="openHistoryLog(item.row.history)"
            title="View history log"
          >
            <i class="fas fa-history"></i>
          </button>
          &nbsp;<button
            class="button is-small is-warning"
            @click="receivePo(item.row)"
            title="Add/Update Receive Info"
          >
            Receive Info
          </button>
        </b-table-column>
      </template>
    </table-pagination>
    <ReceiveModal />
    <HistoryLog />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TablePagination from "../TablePagination.vue";
import ReceiveModal from "./ReceiveModal.vue";
import HistoryLog from "./HistoryLog.vue";
import AppButton from "../frontend/appButton";
import axios from "axios";
import AuthService from "../../_services/auth";
const authService = new AuthService();
const appButton = new AppButton();
import { DateTimeFormatForInput } from "../../helpers/momentFormat";

export default {
  components: {
    TablePagination,
    ReceiveModal,
    HistoryLog
  },
  mounted() {
    this.default();
  },
  computed: {
    ...mapState("purchaseordertoreceive", {
      purchaseOrders: state => state.purchaseOrders,
      isLoadingTable: state => state.isLoadingTable
    })
  },
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: "",
    hasAdminSalesOrSalesPoStaffPriv: authService.hasAdminSalesOrSalesPoStaffPriv(),
    buttonDownloadPoRequest: appButton.isLoadingDefault(false)
  }),
  methods: {
    ...mapActions("purchaseordertoreceive", [
      "getPaginatedPosToReceive",
      "openReceiveInfoModal",
      "openHistoryLogModal"
    ]),
    refreshTable() {
      this.default();
    },
    default() {
      this.getPaginatedPosToReceive({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      });
    },
    receivePo(data) {
      console.log(data);
      data.receivedDate = data.receivedDate
        ? DateTimeFormatForInput(data.receivedDate)
        : null;
      this.openReceiveInfoModal({
        showReceiveModal: true,
        purchaseOrder: data
      });
    },
    openHistoryLog(historyLog) {
      this.openHistoryLogModal({
        showHistoryLog: true,
        historyLog: historyLog
      });
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedPosToReceive({
        page: this.page,
        pageSize: val,
        query: this.search
      });
    },
    page(val) {
      this.getPaginatedPosToReceive({
        page: val,
        pageSize: this.perPage,
        query: this.search
      });
    },
    search(val) {
      this.getPaginatedPosToReceive({
        page: this.page,
        pageSize: this.perPage,
        query: val
      });
    }
  }
};
</script>
